import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ISeries } from 'app/data-studio-redesign/interfaces/data-studio.interface';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Observable, ReplaySubject } from 'rxjs';
import { getSeriesTableData, signalValueFormatter } from 'app/data-studio-redesign/services/data-analysis-helper';
import { DateTimeFormatPreferencePipe } from 'app/shared/pipes/date-time-format-preference/date-time-format-preference.pipe';
import { skip, takeUntil } from 'rxjs/operators';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';
import { compare } from 'app/shared/helper/common.helper';

export type SeriesTableType = 'scatter-plot' | 'time-series';

@Component({
    selector: 'app-series-table',
    templateUrl: './series-table.component.html',
    styleUrls: ['./series-table.component.scss'],
    standalone: false
})
export class SeriesTableComponent implements OnInit, OnChanges {

  @Input() series: ISeries[];
  @Input() loading: boolean;
  @Input() type: SeriesTableType;
  @Input() endTs: number;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public titles: string[];
  public titlesNames: string[];
  public headers;
  public dataSource: MatTableDataSource<ISeries>;
  public timestamps: number[];
  public dataTable: Observable<any[]>;
  public dataJSON: any[];
  public filteredSeries: ISeries[];

  private unsubscriber$: ReplaySubject<boolean> = new ReplaySubject<boolean>();


  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private timezoneService: TimezoneService,
    private dp: DateTimeFormatPreferencePipe)
  { }

  public ngOnInit(): void {
    this.timezoneService.getTimezoneObservable().pipe(takeUntil(this.unsubscriber$), skip(1)).subscribe(({timezone}) => {
      this.prepareDataToExport(timezone);
    })
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.series?.currentValue && this.series.length) {
      this.filteredSeries = this.type === 'time-series' ? this.series.map(serie => ({...serie, chartData: serie.chartData.filter(data => data[0] < this.endTs)})) : this.series
      this.prepareDataToExport(this.timezoneService.selectedOption);
    }
  }

  private prepareDataToExport(timezone:string): void {
    const { titles, titlesNames, data, dataJSON } = getSeriesTableData(this.filteredSeries, this.type, this.dp,timezone);
    this.titles = [...new Set(titles)];
    this.titlesNames = titlesNames;
    this.dataJSON = dataJSON;
    data.forEach(d => this.cleanEmpty(d));
    this.dataJSON.forEach(d => this.cleanEmpty(d));

    setTimeout(() => {
      this.setPagination(data);
    }, 100);
  }

  public setPagination(result) {
    this.dataSource = new MatTableDataSource<any>(result);
    this._changeDetectorRef.detectChanges();
    this.dataSource.paginator = this.paginator;
    this.dataTable = this.dataSource.connect();
  }

  private cleanEmpty(d) {
    return Object.keys(d).forEach(k => d[k] = d[k] !== null ? d[k] : '-');
  }

  public sortData(event) {
    const key = (event.active === 'time' ? 'timestamp' : event.active) as keyof ISeries;
    this.dataSource.data = this.dataSource.data.sort((a, b) => compare(a[key], b[key], event.direction === 'asc'));
    this._changeDetectorRef.detectChanges();
  }

  public getNumberFormat(signalName: string): string {
    return `1.${signalValueFormatter(signalName)}-${signalValueFormatter(signalName)}`;
  }
}
